export class ViewportDimensions {
	public getViewportWidth(): number {
		return Math.max(document.documentElement.clientWidth, window.innerWidth)
	}
}
